import { useEffect } from "react";
import { Toaster } from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import { IAppState } from "store/app-state";
import { setServerError, setServerResponse } from "store/application/application-action";
import { showNotification } from "utils/notification";
import "./ResponseMessage.scss";

export const ResponseMessage = () => {
  const { serverError, serverResponse } = useSelector((state: IAppState) => state.application);
  const dispatch = useDispatch();

  useEffect(() => {
    const TIMER = 2000;
    if (serverResponse) {
      showNotification({
        title: serverResponse,
        variant: "success"
      });
    }
    if (serverError) {
      showNotification({
        title: serverError ? serverError.message : "Server Error.",
        variant: "error"
      });
    }

    const timer = setTimeout(() => {
      dispatch(setServerResponse(null));
      dispatch(setServerError(null));
    }, TIMER);

    return () => clearTimeout(timer);
  }, [serverError, serverResponse, dispatch]);

  return (
    <Toaster
      position="bottom-center"
      reverseOrder={true}
      toastOptions={{
        className: "toastItem",
      }}
    />
  );
};
